import React from 'react';
import ProductsList from "../../../component/productsList/ProductsList";
import { gql } from "apollo-boost";
import PropTypes from 'prop-types';
import { PRODUCT_FRAGMENT } from "../../../component/productPreview/ProductPreview";
import { PRODUCT_DETAILS_PRELOAD_FRAGMENT } from "../../product/Product";
import useProductSearchVariables from "./hooks/useProductSearchVariables";

const SEE_PRODUCTS = gql`
    query SeeProducts($filter: ProductFilter!, $offset: Int, $limit: Int, $sort: String) {
        searchProducts(filter: $filter, offset: $offset, limit: $limit, sort: $sort) {
            ...ProductFragment
            ...ProductDetailsPreloadFragment
            price
        }
    }
    ${PRODUCT_FRAGMENT}
    ${PRODUCT_DETAILS_PRELOAD_FRAGMENT}
`;

/**
 * 검색 결과 상품 컨테이너 컴포넌트
 * 필터와 키워드를 기반으로 상품 검색 API를 호출하고 결과를 표시합니다.
 * 데이터 로직을 `useProductSearchVariables` 훅으로 분리하여 가독성과 재사용성을 높였습니다.
 */
const SearchProductContainer = ({ className, keyword, filters, sortValue = 'RELEVANCE', schemaOrgPreview }) => {
    const variables = useProductSearchVariables(keyword, filters, sortValue);

    return (
        <div className={className}>
            <ProductsList
                itemsProperty="searchProducts"
                query={SEE_PRODUCTS}
                variables={variables}
                limit={40}
                key={`products-${JSON.stringify(variables)}`}
                schemaOrgPreview={schemaOrgPreview}
                keyword={keyword}
            />
        </div>
    );
};

SearchProductContainer.propTypes = {
    className: PropTypes.string,
    keyword: PropTypes.string,
    filters: PropTypes.object,
    sortValue: PropTypes.string,
    schemaOrgPreview: PropTypes.object,
};

export default SearchProductContainer;
